import { render, staticRenderFns } from "./SoshCommitments.vue?vue&type=template&id=6e4c49b3"
import script from "./SoshCommitments.vue?vue&type=script&lang=js"
export * from "./SoshCommitments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports